import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {DataTable} from "primereact/datatable";
import axios from "axios";
import {Column} from "primereact/column";
import {Toast} from "primereact/toast";
import {Button} from "primereact/button";
import Spinner from "../../spinner/Spinner";
import {InputText} from "primereact/inputtext";


const Images = props => {
    const toast = useRef(null);
    const [images, setImages] = useState([]);
    const [loadingState, setLoadingState] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const image_list_role = localStorage.getItem('cloud_image_list') ? true : false;


    useEffect(() => {
        getImages();
    }, []);

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const getImages = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/cloud-image/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        ////console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {

                            setImages(data.images);
                            showSuccess("İmajlar Listelendi.");
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getImageBody = (compute_key, compute_name) => {
        const imageBody = (rowData) => {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12" style={{wordBreak: "break-all"}}>
                                {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return imageBody;
    }

    const getHeader = (value) => {
        return (
            <div align="center">{value}</div>
        );
    }

    const reset = () => {
        setGlobalFilter('');
    }

    const tableHeader = (
        <div className="table-header">
            <div className="p-grid">
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-8 p-xl-8">
                    <h4><b>İŞLETİM SİSTEMİ İMAJLARI</b></h4>
                </div>
                <div className="p-col-12 p-sm-12 p-md-2 p-lg-1 p-xl-1" align="right">
                    <Button type="button" title="Filtreyi Temizle"
                            className="p-button-outlined"
                            icon="pi pi-eye-slash"
                            onClick={reset}/>
                </div>
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-3 p-xl-3">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search"/>
                        <InputText type="search" value={globalFilter}
                                   onChange={(e) => setGlobalFilter(e.target.value)}
                                   placeholder="Genel Arama"/>
                    </span>
                </div>
            </div>


        </div>
    );


    if (image_list_role) {
        return (
            <div className='p-fluid'>
                <Toast ref={toast}/>
                <Spinner loadingState={loadingState}/>
                <div className="datatable-responsive-demo">
                    <div className='card'>
                        <DataTable
                            value={images}
                            className='p-datatable-responsive-demo'
                            paginator rows={10}
                            globalFilter={globalFilter}
                            header={tableHeader}
                            emptyMessage="Kayıt Bulunamadı"
                        >
                            <Column field="name"
                                    header="İmaj Adı"
                                    body={getImageBody("name", "İmaj Adı")}
                                    style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    filter
                                    filterPlaceholder="İmaj Adı"
                            />
                            <Column field="status"
                                    header="Durum"
                                    body={getImageBody("status", "Durum")}
                                    style={{textAlign: 'center', width: '5.5em'}}
                            />
                            <Column field="size"
                                    header="Boyut"
                                    body={getImageBody("size", "Boyut")}
                                    style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    filter
                                    filterPlaceholder="İmaj Boyutu"
                            />
                            <Column field="updated_time"
                                    header="Güncelleme Tarihi"
                                    body={getImageBody("updated_time", "Güncelleme Tarihi")}
                                    style={{textAlign: 'center', width: '5.5em'}}
                            />
                            {/*<Column header={getHeader("İŞLEVLER")}
                                body={processBody}/>*/}
                        </DataTable>
                    </div>
                </div>

            </div>
        );
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Images);


// WEBPACK FOOTER //
// ./src/pages/cloudmanagement/Images.jsx